import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { StaticHtmlTemplateC } from "./staticHtmlTemplateC";
import { StaticHtmlTemplateD } from "./staticHtmlTemplateD";
import { StaticHtmlTemplate } from "./staticHtmlTemplate";
import { StaticHtmlTemplateE } from "./staticHtmlTemplateE";
import { getPaperConfig } from "./paperSize";
const NewVisitingDuplex = React.forwardRef(({ vistingDuplexRef }, ref) => {
  const { printingData, card_size, paper_size } = useSelector(
    (state) => state.printing,
  );
  const paper = getPaperConfig(paper_size);
  // Back card box is derived (3% larger than the front footprint, plus the size's backBleedX/Y).
  const backW = paper.back.cardWidth;
  const backH = paper.back.cardHeight;

  const splitPrintingData = (data) => {
    const chunkSize = paper.chunkSize;
    const chunks = [];
    for (let i = 0; i < data?.length; i += chunkSize) {
      chunks?.push(data?.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const chunks = splitPrintingData(printingData);

  // Trim only the FINAL page by lastPageTrimPerPage * (PDF page count) — a margin that grows
  // with the number of pages (html2canvas's sub-pixel height excess accumulates per page), so
  // the total clears html2pdf's page-count boundary at any size; every full page stays
  // paper.pageHeight (no drift). Duplex = 2 pages per chunk, so page count = 2 * chunks.length,
  // and the final page is the LAST chunk's BACK, so only that div is trimmed (front stays full).
  const pageHeightFor = (chunkIndex) =>
    chunkIndex === chunks.length - 1
      ? paper.pageHeight -
        (paper.lastPageTrimPerPage
          ? Math.max(2, paper.lastPageTrimPerPage * chunks.length * 2)
          : 0)
      : paper.pageHeight;

  return (
    <div ref={vistingDuplexRef}>
      <title>DHC Card</title>
      <div style={{ boxSizing: "border-box" }}>

        {
          chunks?.map((chunk, chunkIndex) =>(
            <>
            <div style={{ height: `${paper.pageHeight}px` }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "start",
              columnGap: paper.front.columnGap,
              rowGap: paper.front.rowGap,
              fontFamily: "'Graphik',san-serif",
              paddingLeft: paper.front.paddingLeft,
              paddingRight: paper.front.paddingRight,
              width: paper.containerWidth,
              fontSize: 8,
              // Left-aligned; A5 centers vertically, A3/A4 stay top-aligned (paddingTop).
              ...(paper.verticalCenter
                ? { height: "100%", alignContent: "center" }
                : { paddingTop: paper.front.paddingTop }),
            }}
          >
            {chunk?.map((value, mainIndex) => {
              let template;

              if (value?.center_stone_side_stone) {
                template = <StaticHtmlTemplateC value={value} sideMargin={paper.cardSideMargin} topMargin={paper.cardTopMargin} />;
              } else if (parseInt(value?.qr_and_image_format) === 3) {
                template = <StaticHtmlTemplateD value={value} sideMargin={paper.cardSideMargin} topMargin={paper.cardTopMargin} />;
              } else {
                card_size === 1
                  ? (template = <StaticHtmlTemplate value={value} sideMargin={paper.cardSideMargin} topMargin={paper.cardTopMargin} />)
                  : (template = <StaticHtmlTemplateE value={value} sideMargin={paper.cardSideMargin} topMargin={paper.cardTopMargin} />);
              }

              return (
                <React.Fragment key={mainIndex}>{template}</React.Fragment>
              );
            })}
          </div>
        </div>
        {/* <div className="html2pdf__page-break"></div> */}

        {/* Back */}
        <div style={{ height: `${pageHeightFor(chunkIndex)}px` }}>
          <div
            style={{
              display: "flex",
              alignItems: "start",
              flexDirection: "row-reverse",
              flexWrap: "wrap",
              columnGap: paper.back.columnGap,
              rowGap: paper.back.rowGap,
              paddingLeft: paper.back.paddingLeft,
              paddingRight: paper.back.paddingRight,
              width: paper.containerWidth,
              fontSize: 8,
              // Back mirrored left<->right (row-reverse). A5 centers vertically; paddingTop then
              // nudges the centered block DOWN by paddingTop/2 (border-box keeps it on-page).
              // A3/A4 stay top-aligned via paddingTop.
              ...(paper.verticalCenter
                ? {
                    height: "100%",
                    boxSizing: "border-box",
                    alignContent: "center",
                    paddingTop: paper.back.paddingTop,
                  }
                : { paddingTop: paper.back.paddingTop }),
            }}
          >
            {chunk?.map((value, index) => {
              return (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#ffffff",
                    maxWidth: backW,
                    minWidth: backW,
                    width: backW,
                    maxHeight: backH,
                    minHeight: backH,
                    height: backH,
                    lineHeight: 0,
                    border: "1px solid #f3f3f3",
                    padding: 0,
                    margin: 0,
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={value?.back_image}
                    width={backW}
                    height={backH}
                    alt="back_image"
                    style={{
                      width: "100%",
                      height: "100%",
                      lineHeight: 0,
                      padding: 0,
                      margin: 0,
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
            </>
          ))
        }
      </div>
    </div>
  );
});

export default NewVisitingDuplex;
